/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Standalone_Field_CityInputs */

const cs_social_standalone_field_city = /** @type {(inputs: Social_Standalone_Field_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Město (volitelné)`)
};

const en_social_standalone_field_city = /** @type {(inputs: Social_Standalone_Field_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City (optional)`)
};

/**
* | output |
* | --- |
* | "City (optional)" |
*
* @param {Social_Standalone_Field_CityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_standalone_field_city = /** @type {((inputs?: Social_Standalone_Field_CityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Standalone_Field_CityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_standalone_field_city(inputs)
	return cs_social_standalone_field_city(inputs)
});